/* Töpferkunst Startseite – Einblend-Animation + FAQ-Akkordeon.
   Jeder TK-Abschnitt bindet diese Datei ein; der Guard sorgt dafür, dass sie nur EINMAL läuft
   (sonst würde jeder FAQ-Klick mehrfach umschalten). */
(function () {
  'use strict';
  if (window.tkHomeInit) return;
  window.tkHomeInit = true;

  var obs = null;
  function reveal(root) {
    var els = root.querySelectorAll('.tk-home .tk-fade:not(.visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    if (!obs) {
      obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { obs.observe(el); });
  }

  // FAQ über einen einzigen Klick-Handler (Event-Delegation): funktioniert für jeden
  // FAQ-Abschnitt, auch wenn der Theme-Editor ihn neu rendert.
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('.tk-home .tk-faq-btn') : null;
    if (!btn) return;
    var item = btn.parentElement;
    var scope = btn.closest('.tk-faq') || document;
    var isOpen = item.classList.contains('open');
    scope.querySelectorAll('.tk-faq-item').forEach(function (i) {
      i.classList.remove('open');
      var b = i.querySelector('.tk-faq-btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) { item.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
  });

  var ric = window.requestIdleCallback || function (cb) { setTimeout(cb, 100); };
  function start() { ric(function () { reveal(document); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Theme-Editor: neu gerenderte Abschnitte sofort sichtbar machen
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.tk-fade').forEach(function (el) { el.classList.add('visible'); });
  });
})();
